import request from '@/utils/request'


// 异常检测列表查询
export const queryAnomalyList = (params) => {
  return request({
    url: '/tinggoadmin/risk/anomaly/list',
    method: 'get',
    params
  })
}

// 异常检测详情
export const queryAnomalyDetail = (id) => {
  return request({
    url: `/tinggoadmin/risk/anomaly/detail/${id}`,
    method: 'get'
  })
}

// 操作日志查询（风控模块）
export const queryRiskOperationLogList = (params) => {
  return request({
    url: '/tinggoadmin/risk/operationLog/list',
    method: 'get',
    params
  })
}

// 登录日志查询（风控模块）
export const queryRiskLoginLogList = (params) => {
  return request({
    url: '/tinggoadmin/risk/loginLog/list',
    method: 'get',
    params
  })
}

// ==================== 名单管理 ====================

// 获取名单统计数据
export const getRiskListStats = () => {
  return request({
    url: '/tinggoadmin/riskList/stats',
    method: 'get'
  })
}

// 分页查询名单列表
export const queryRiskListPage = (params) => {
  return request({
    url: '/tinggoadmin/riskList/list',
    method: 'get',
    params
  })
}

// 新增名单
export const addRiskList = (data) => {
  return request({
    url: '/tinggoadmin/riskList/add',
    method: 'post',
    data
  })
}

// 删除名单
export const deleteRiskList = (id) => {
  return request({
    url: `/tinggoadmin/riskList/delete/${id}`,
    method: 'delete'
  })
}

// 批量删除名单
export const batchDeleteRiskList = (idList) => {
  return request({
    url: '/tinggoadmin/riskList/batchDelete',
    method: 'delete',
    data: idList
  })
}

// ==================== 订单风控查询 ====================

// 订单风控列表查询
export const queryOrderRiskTraceList = (params) => {
  return request({
    url: '/tinggoadmin/risk/order/trace/list',
    method: 'get',
    params
  })
}

// 根据订单号查询风控详情
export const queryOrderRiskTrace = (orderNo) => {
  return request({
    url: `/tinggoadmin/risk/order/trace/${orderNo}`,
    method: 'get'
  })
}

// ==================== 策略配置 ====================

// 获取策略配置概览
export const getPolicyConfigOverview = () => {
  return request({
    url: '/tinggoadmin/risk/policy/overview',
    method: 'get'
  })
}

// 获取规则列表
export const queryRuleList = () => {
  return request({
    url: '/tinggoadmin/risk/policy/rules',
    method: 'get'
  })
}

// 更新规则配置
export const updateRule = (data) => {
  return request({
    url: '/tinggoadmin/risk/policy/rule/update',
    method: 'put',
    data
  })
}

// 切换规则开关
export const toggleRuleStatus = (ruleCode) => {
  return request({
    url: `/tinggoadmin/risk/policy/rule/toggle/${ruleCode}`,
    method: 'put'
  })
}

// 获取评分阈值配置
export const getScoreThreshold = () => {
  return request({
    url: '/tinggoadmin/risk/policy/threshold',
    method: 'get'
  })
}

// 更新评分阈值配置
export const updateScoreThreshold = (data) => {
  return request({
    url: '/tinggoadmin/risk/policy/threshold/update',
    method: 'put',
    data
  })
}

// 发布配置
export const publishPolicyConfig = () => {
  return request({
    url: '/tinggoadmin/risk/policy/publish',
    method: 'post'
  })
}
